var tri = require("tripartite"); var t = "<label>\n\t__label__\n\t<textarea name=\"__name__\" id=\"__id__\" rows=\"5\" >__value__<\/textarea>\n<\/label>"; 
module.exports = tri.addTemplate("webhandle-page-editor/textarea-template", t); 